import { IOrderCompleted } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersCompleted: IOrderCompleted[] = [
  {
    userRole: 'EVA',
    id: 'first-completed-order',
    date: timestampMockHelpers.now,
    createdAt: timestampMockHelpers.now,
    createdBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.now,
    updatedBy: 'BERNHARD',
    status: 'INTERNAL_ORDER_COMPLETED',
    position: 'Some Position on an internal order',
    total: 123.45,
    paymentInterval: 'MONTHLY',
    paymentIntervalXMonths: 2,
  },
  {
    userRole: 'EVA',
    id: 'second-completed-order',
    date: timestampMockHelpers.now,
    createdAt: timestampMockHelpers.now,
    createdBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.now,
    updatedBy: 'BERNHARD',
    status: 'INTERNAL_ORDER_COMPLETED',
    position: 'Some Position on another internal order',
    total: 98.76,
    paymentInterval: 'YEARLY',
    paymentIntervalXMonths: 12,
  },
];
